export const COLUMNS = {
  supplier: 'supplier',
  businessUnit: 'businessUnit',
  country: 'country',
  expenseType: 'expenseType',
  spendType: 'spendType',
  apSpendCategoryL1: 'apSpendCategoryL1',
  apSpendCategoryL2: 'apSpendCategoryL2',
  ruleId: 'ruleId',
};

export const GROUP_COLUMNS = [
  'supplier',
  'businessUnit',
  'country',
  'expenseType',
  'spendType',
];

export const COLUMN_DEFS = [
  {
    field: COLUMNS.ruleId,
    filter: 'agNumberColumnFilter',
    width: 100,
  },
  {
    field: COLUMNS.supplier,
  },
  {
    field: COLUMNS.businessUnit,
  },
  {
    field: COLUMNS.country,
  },
  {
    headerName: 'Taxonomy',
    marryChildren: true,
    children: [
      {
        field: COLUMNS.apSpendCategoryL1,
        lockVisible: true,
        cellRenderer: 'ruleCellRenderer',
      },
      {
        field: COLUMNS.apSpendCategoryL2,
        lockVisible: true,
        cellRenderer: 'ruleCellRenderer',
      },
    ],
  },
  {
    field: COLUMNS.expenseType,
  },
  {
    field: COLUMNS.spendType,
  },
];

export const gridConfig = {
  columnDefs: COLUMN_DEFS,
};

export default gridConfig;
